import { useThemeStore } from "@stores/theme.store";
import { Select } from "antd";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { SchoolService } from "@services/school.service";
import { StudentTahfidzAbsence } from "@services/dtos/school.dto";
import { useQuery } from "@tanstack/react-query";
import { Spiner } from "@components/loaders/spiner";
import { FcFinePrint } from "react-icons/fc";
moment.locale("id");

const statusColor: Record<string, string> = {
  hadir: "tw-bg-green-100 tw-text-green-700",
  "hadir terlambat": "tw-bg-blue-100 tw-text-blue-700",
  sakit: "tw-bg-orange-100 tw-text-orange-700",
  izin: "tw-bg-orange-100 tw-text-orange-700",
  alpa: "tw-bg-red-100 tw-text-red-700",
};

export const TahfidzAbsenceDataPage = () => {
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [limit, setLimit] = useState<string>("10");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [
      SchoolService.queries.GET_SCHOOL_STUDENT_TAHFIDZ_ABSENCE,
      nis,
      limit,
    ],
    queryFn: () => SchoolService.studentTahfidzAbsence({ nis, limit }),
    enabled: !!nis,
  });

  useEffect(() => {
    setAppBar({ title: "Absensi Tahfidz", show: true, leading: "back" });
    setHeader({ buttonBack: true, filter: false, title: "Absensi Tahfidz" });
  }, [setHeader, setAppBar]);

  const renderItem = (item: StudentTahfidzAbsence, idx: number) => {
    const colorClass =
      statusColor[item.absensi?.toLowerCase()] ??
      "tw-bg-gray-100 tw-text-gray-700";
    return (
      <div
        key={idx}
        className="tw-border-solid tw-border-x-0 tw-border-y-1 tw-border-y-other-200 tw-py-2 tw-mb-0.5"
      >
        <div className="tw-px-2 tw-flex tw-justify-between tw-items-center">
          <div className="tw-text-sm tw-font-semibold">
            {moment(item.tanggal).format("DD MMMM YYYY")}
          </div>
          <span
            className={`tw-text-xs tw-font-medium tw-px-2 tw-py-0.5 tw-rounded-full ${colorClass}`}
          >
            {item.absensi}
          </span>
        </div>

        {item.catatan ? (
          <div className="tw-px-2 tw-text-xs tw-text-other-500 tw-mt-0.5">
            Catatan: {item.catatan}
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <div className="tw-bg-other-100 tw-rounded-lg card-body">
          <div className="tw-text-xs tw-mb-1">Filter Data</div>
          <Select
            className="tw-border-other-0 tw-text-base"
            placeholder="Pilih Jumlah Ditampilkan"
            defaultValue={limit}
            style={{ width: "100%" }}
            allowClear
            onChange={(e) => setLimit(e ?? "10")}
            options={[
              { value: "10", label: "10" },
              { value: "25", label: "25" },
              { value: "50", label: "50" },
              { value: "100", label: "100" },
            ]}
          />
          <p className="tw-mt-3 tw-text-sm">
            Data yang ditampilkan {limit} data terakhir
          </p>
        </div>

        <div className="tw-bg-other-100 tw-rounded-lg card-body tw-mt-3">
          {isPending ? (
            <div className="tw-text-center">
              <Spiner />
            </div>
          ) : data?.data != null && data.data.length > 0 ? (
            <>{data.data.map((item, idx) => renderItem(item, idx))}</>
          ) : (
            <div className="tw-p-8 tw-text-center">
              <FcFinePrint size={50} />
              <div>Data tidak ditemukan</div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
